import Modal from "components/atoms/modal";
import { H4, TextSm } from "components/atoms/text";
import Btn from "components/atoms/buttons";
import useDeleteUserMe from "apis/mutations/user/useDeleteUserMe";
import useDeleteCompanyMe from "apis/mutations/company/useDeleteCompanyMe";

interface Props {
  onClose: () => void;
  type: "user" | "company";
  onError: (message?: string | string[]) => void;
}

// 회원탈퇴 재 안내
const ModalDeleteMe = ({ onClose, onError, type }: Props) => {
  // 탈퇴 api - 일반회원
  const deleteUserMe = useDeleteUserMe({ onError });

  // 탈퇴 api - 전문가회원
  const deleteCompanyMe = useDeleteCompanyMe({ onError });

  // 탈퇴 클릭 이벤트
  const handleDelete = () => {
    if (type === "user") {
      deleteUserMe();
    } else {
      deleteCompanyMe();
    }
  };

  return (
    <Modal.Container className="w-[312px] p-10 rounded-16 text-center">
      <H4 className="mb-3">회원탈퇴</H4>
      <TextSm>정말로 탈퇴 하시겠습니까?</TextSm>
      <div className="flex gap-5 mt-9">
        <Btn.Gray onClick={onClose} size="large" className="flex-1">
          취소
        </Btn.Gray>
        <Btn.Red onClick={handleDelete} size="large" className="flex-1">
          탈퇴
        </Btn.Red>
      </div>
    </Modal.Container>
  );
};

export default ModalDeleteMe;
